export class Cartonagem {
    id;
    descricao: string;
    ativo: string;
    dataCadastro: string;
    idEmpresa: number;
}